import { useQueryClient } from '@tanstack/react-query'
import { useRef } from 'react'
import { useNavigate } from 'react-router-dom'
import type ReactSignatureCanvas from 'react-signature-canvas'
import { toast } from 'sonner'

import { QUERY_KEYS } from '@/modules/shared/constants/query-keys.contant'
import { useResolveRequestHook } from '@/modules/shared/hooks/use-resolve-request.hook'


import { useMainStore } from '@/modules/shared/stores/main.store'
import { useOrderFormClearData } from '../../../hooks/use-order-form-clear-data.hook'
import { useOrderFormStore } from '../../../stores/order-form.store'
import { useOrderFormComponentStore, useOrderFormComponentStoreActions } from '../../../stores/order-form-component.store'
import { useSaveSignatureOrderMutation } from '../../../mutations/save-signature-order.mutation'
import { useSaveOrderMutation } from '../../../mutations/save-order.mutation'

export const useModalSignature = () => {
  const signatureRef = useRef<ReactSignatureCanvas | null>(null)

  const navigate = useNavigate()

  const queryClient = useQueryClient()


	const {
    initialLocationForOrder,
    actions: { setInitialLocationForOrder },
  } = useMainStore()

  const { clearAllDataOfOrder } = useOrderFormClearData()

	const callbackToRequest = async () => {

    queryClient.invalidateQueries({
      queryKey: [QUERY_KEYS.ORDERS],
    })
    queryClient.removeQueries({
      queryKey: ['orderForm', 'new'],
    })
    await queryClient.invalidateQueries([QUERY_KEYS.ORDER_TRANSMISSION])

    if (openModalScheduleAfterSave) {
      setOpenModalScheduleAfterSave(false)
      setIsOpenModalSchedule(true)
      return
    }

    clearAllDataOfOrder()

    if (initialLocationForOrder) {
      setInitialLocationForOrder(undefined)
      navigate('/clientes')
    } else {
      navigate('/pedidos')
    }
  }


  const { checkStatusOnRequest } = useResolveRequestHook()

	const { saveOrderFn, isSavingOrder } = useSaveOrderMutation({
    callback: callbackToRequest,
    resolveRequest: checkStatusOnRequest,
  })

  const { jsonOrderForm } = useOrderFormStore()
  const { isOpenModalSignatureOrder } = useOrderFormComponentStore()
  const {
    setIsOpenModalSignatureOrder,
    setIsOpenModalSchedule,
    setOpenModalScheduleAfterSave,
  } = useOrderFormComponentStoreActions


  const { openModalScheduleAfterSave } = useOrderFormComponentStore()

  const callbackSaveSignature = () => {
    setIsOpenModalSignatureOrder(false)

    if (openModalScheduleAfterSave) {
      setOpenModalScheduleAfterSave(false)
      setIsOpenModalSchedule(true)
      return
    }
    navigate('/pedidos')

    clearAllDataOfOrder()

    queryClient.invalidateQueries({
      queryKey: [QUERY_KEYS.ORDERS],
    })
  }

  const { saveSignatureFn, isSavingSignature } = useSaveSignatureOrderMutation({
    callback: callbackSaveSignature,
    resolveRequest: checkStatusOnRequest,
  })

  const handleClearSignature = () => {
    if (signatureRef.current) {
      signatureRef.current.clear()
    }
  }

  const handleSaveSignature = async () => {

		if (isSavingOrder) {
			return
		}
    if (!signatureRef.current.isEmpty()) {
      await saveSignatureFn({
        orderId: jsonOrderForm?.idPedidoCel.toString(),
        signature: signatureRef.current?.toDataURL(),
      }).then(async () => {
				toast.success('Assinatura salva com sucesso!')
				await saveOrderFn({ jsonOrderForm }).then(() => {
					toast.success('Pedido salvo com sucesso!')
				})
			})
      return
    }

    toast.info('Para continuar, por favor, assine o documento!')
  }

  const handleCloseModalSignature = () => {
    setIsOpenModalSignatureOrder(false)
  }

  return {
    signatureRef,
    handleSaveSignature,
    handleClearSignature,
    isOpenModalSignatureOrder,
    handleCloseModalSignature,
		isSavingOrder: isSavingOrder || isSavingSignature,
  }
}
